import { render, staticRenderFns } from "./Qualidade.vue?vue&type=template&id=7a8bd597&scoped=true&"
import script from "./Qualidade.vue?vue&type=script&lang=js&"
export * from "./Qualidade.vue?vue&type=script&lang=js&"
import style0 from "./Qualidade.vue?vue&type=style&index=0&id=7a8bd597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8bd597",
  null
  
)

export default component.exports